import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminRoutingModule } from './admin-routing.module';
import { CertificateTypeComponent } from './components/certificate-type/certificate-type.component';
import { ConstructionElementTypeComponent } from './components/construction-element-type/construction-element-type.component';
import { FrameMaterialComponent } from './components/frame-material/frame-material.component';
import { GlassTypeComponent } from './components/glass-type/glass-type.component';
import { GlassUnitComponent } from './components/glass-unit/glass-unit.component';
import { GlassCoatingCodeComponent } from './components/glass-coating-code/glass-coating-code.component';
import { InstituteTypeComponent } from './components/institute-type/institute-type.component';
import { TestPurposeComponent } from './components/test-purpose/test-purpose.component';
import { TestTypeComponent } from './components/test-type/test-type.component';
import { InstituteComponent } from './components/institute/institute.component';
import { ProjectConfidentialityLevelComponent } from './components/project-confidentiality-level/project-confidentiality-level.component';
import { GlassManufacturerComponent } from './components/glass-manufacturer/glass-manufacturer.component';
import { PerformanceCriteriaComponent } from './components/performance-criteria/performance-criteria.component';
import { ProjectPurposeComponent } from './components/project-purpose/project-purpose.component';
import { StandardComponent } from './components/standard/standard.component';
import { CostTypeComponent } from './components/cost-type/cost-type.component';
import { OrganisationalUnitComponent } from './components/organisational-unit/organisational-unit.component';
import { PartnerComponent } from './components/partner/partner.component';
import { PartnerTypeComponent } from './components/partner-type/partner-type.component';
import { ProjectOwnerTypeComponent } from './components/project-owner-type/project-owner-type.component';
import { ProjectStatusComponent } from './components/project-status/project-status.component';
import { RegionComponent } from './components/region/region.component';
//import { ToolbarModule } from 'primeng/toolbar';
import { PrimeNgModules } from '../../app/primeng.module';
import { TranslateModule } from '@ngx-translate/core';
import { GroupTypeComponent } from './components/group-type/group-type.component';
import { GroupComponent } from './components/group/group.component';
import { CountryComponent } from './components/country/country.component';
import { TestTypeStandardComponent } from './components/test-type-standard/test-type-standard.component';
import { CertificateTypeStandardComponent } from './components/certificate-type-standard/certificate-type-standard.component';
import { SaveStandardComponent } from './components/save-standard/save-standard.component';
import { SavePerformanceCriteriaComponent } from './components/save-performance-criteria/save-performance-criteria.component';
import { FrameNameComponent } from './components/frame-name/frame-name.component';
import { FrameComponent } from './components/frame/frame.component';
import { SaveFrameComponent } from './components/save-frame/save-frame.component';
import { ResultFailureReasonComponent } from './components/result-failure-reason/result-failure-reason.component';
import { ResultUnitComponent } from './components/result-unit/result-unit.component';
import { ComponentCausedFailureComponent } from './components/component-caused-failure/component-caused-failure.component';
import { BeadPositionComponent } from './components/bead-position/bead-position.component';
import { MountingDirectionComponent } from './components/mounting-direction/mounting-direction.component';
import { SupportingConstructionComponent } from './components/supporting-construction/supporting-construction.component';
import { GlassBehaviourComponent } from './components/glass-behaviour/glass-behaviour.component';




@NgModule({
  declarations: [
    CertificateTypeComponent,
    ConstructionElementTypeComponent,
    FrameMaterialComponent,
    GlassTypeComponent,
    GlassUnitComponent,
    ResultUnitComponent,
    BeadPositionComponent,
    ComponentCausedFailureComponent,
    GlassCoatingCodeComponent,
    InstituteTypeComponent,
    TestPurposeComponent,
    TestTypeComponent,
    InstituteComponent,
    ProjectConfidentialityLevelComponent,
    GlassManufacturerComponent,
    PerformanceCriteriaComponent,
    ProjectPurposeComponent,
    StandardComponent,
    CostTypeComponent,
    OrganisationalUnitComponent,
    PartnerComponent,
    PartnerTypeComponent,
    ProjectOwnerTypeComponent,
    ProjectStatusComponent,
    RegionComponent,
    GroupTypeComponent,
    GroupComponent,
    CountryComponent,
    TestTypeStandardComponent,
    CertificateTypeStandardComponent,
    SaveStandardComponent,
    SavePerformanceCriteriaComponent,
    FrameNameComponent,
    FrameComponent,
    SaveFrameComponent,
    ResultFailureReasonComponent,
    MountingDirectionComponent,
    SupportingConstructionComponent,
    GlassBehaviourComponent,
   
  ],
  imports: [
    FormsModule,
    CommonModule,
    TranslateModule,
    AdminRoutingModule,
   // ToolbarModule,
    ...PrimeNgModules,
    
  ]
})
export class AdminModule { }
